module.exports = __webpack_public_path__ + "static/media/body-background.f50d16e0.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/body-background.png
 ** module id = 666
 ** module chunks = 0
 **/